<template>
  <div>
    <b-form-group
      label="Root"
      label-for="input_root"
      label-cols-sm="3"
      v-if="viewComponentModel.level !== 1"
    >
      <label class="col-form-label col-sm-7">{{
        viewComponentModel.root
      }}</label>
    </b-form-group>
    <b-form-group label="รหัส" label-for="input_code" label-cols-sm="3">
      <label class="col-form-label col-sm-7">{{
        viewComponentModel.code
      }}</label>
    </b-form-group>
    <b-form-group
      label="ชื่อ (ไทย)"
      label-for="input_displayname_th"
      label-cols-sm="3"
    >
      <label class="col-form-label col-sm-7">{{
        viewComponentModel.display_name.th
      }}</label>
    </b-form-group>
    <b-form-group
      label="ชื่อ (อังกฤษ)"
      label-for="input_displayname_en"
      label-cols-sm="3"
    >
      <label class="col-form-label col-sm-7">{{
        viewComponentModel.display_name.en
      }}</label>
    </b-form-group>
    <b-form-group
      label="Commission Rate (%)"
      label-for="input_commission_rate"
      label-cols-sm="3"
    >
      <label class="col-form-label col-sm-7">{{
        viewComponentModel.commission_rate
      }}</label>
    </b-form-group>
    <b-form-group label="สถานะ" label-for="input_status" label-cols-sm="3">
      <label class="col-form-label col-sm-7">
        <label :class="`label label-${statusLabel}`">
          {{ viewComponentModel.status }}
        </label>
      </label>
    </b-form-group>
    <b-form-group
      label="สำหรับจัดการสินค้า"
      label-for="input_is_control_product"
      label-cols-sm="3"
    >
      <label class="col-form-label col-sm-7">
        <label
          class="label label-yes"
          v-if="viewComponentModel.is_control_product"
          >Yes</label
        >
        <label class="label label-no" v-else>No</label>
      </label>
    </b-form-group>
    <div
      class="form-group row mb-4"
      v-if="viewComponentModel.is_control_product"
    >
      <label class="col-form-label col-sm-3">หมวดเพิ่มเติม</label>
      <div class="col-sm-9">
        <div class="row">
          <div class="col-sm-12">
            <template
              v-for="(item, index) in viewComponentModel.categoriesMappedItems"
            >
              <b-alert show variant="secondary" v-bind:key="index"
                ><b>[{{ item.name }}]</b> {{ item.root }}</b-alert
              >
            </template>
          </div>
        </div>
      </div>
      <!-- <div class="col-sm-9">
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive" >
              <b-table
                class="table table-centered table-nowrap"
                ref="categoriesMappedTable"
                :empty-text="'ไม่พบข้อมูล'"
                :show-empty="!viewComponentModel.categoriesMappedItems || viewComponentModel.categoriesMappedItems.length == 0"
                :bordered="true"
                :items="viewComponentModel.categoriesMappedItems"
                align="center"
                v-bind:fields="fieldsDetail"
              >
                <template v-slot:cell(index)="data">
                  <div class="text-right">
                    {{ (data.index + 1) | number }}
                  </div>
                </template>
                <template v-slot:cell(root)="data">
                   <b-alert show variant="secondary" v-bind:key="index">
                         {{ data.value }}</b-alert>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="form-group row mb-4">
      <label class="col-form-label col-lg-3">กลุ่มคุณสมบัติสินค้า</label>
      <div class="col-lg-9">
        <b-table
          class="table table-centered table-nowrap"
          ref="catalogtable"
          :empty-text="'ไม่พบข้อมูล'"
          :show-empty="
            attributsetItems === null ||
              attributsetItems === undefined ||
              (attributsetItems && attributsetItems.length === 0)
          "
          :bordered="true"
          :items="attributsetItems"
          align="center"
          v-bind:fields="attributsetFields"
        >
          <template v-slot:cell(index)="data">
            <div class="text-right">
              {{ (data.index + 1) | number }}
            </div>
          </template>
          <template v-slot:cell(status)="data">
            <span
              class="label"
              :class="'label-' + data.value.toLowerCase()"
              v-html="data.value"
            ></span>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { StatusEnum } from '@/enum/status.enum.js'
import { FormatQty } from '@/helpers/utils/format-qty.js'
import attributesetsService from '@/helpers/service/attributesets-service'

export default {
  name: 'HybridCategoryDetailView',
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {
        return this.viewComponentModel
      },
    },
  },
  mounted() {},
  data() {
    return {
      viewComponentModel: {
        root: null,
        id: null,
        parent_id: null,
        level: 0,
        code: null,
        display_name: {
          th: '',
          en: '',
        },
        categoriesMappedItems: [],
        commission_rate: null,
        is_control_product: false,
        is_commission_rate: false,
        status: StatusEnum.ACTIVE,
        categories_mapped: [
          {
            type: null,
            id: null,
            parent_id: null,
            level: 0,
            code: null,
            mdc_code: 0,
            display_name: {
              th: '',
              en: '',
            },
            parent_categories: [
              {
                id: null,
                parent_id: null,
                level: 0,
                code: null,
                mdc_code: 0,
                display_name: {
                  th: '',
                  en: '',
                },
              },
            ],
          },
        ],
      },
      attributsetItems: [],
      attributsetFields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'display_name.th',
          label: 'ชื่อกลุ่มคุณสมบัติ',
          sortable: true,
        },
        {
          key: 'status',
          label: 'สถานะ',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
      ],
      fieldsDetail: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'name',
          label: 'ชื่อหมวดหมู่',
          sortable: true,
        },
        {
          key: 'root',
          label: 'Root',
          sortable: true,
        },
        // {
        //   key: 'action',
        //   label: 'Action',
        //   thStyle: 'width:80px',
        // },
      ],
    }
  },
  created: function() {
    if (this.value) {
      this.viewComponentModel = this.value
      if (this.value.id && this.value.id !== '') {
        this.onGetAttributeSetsFromHybrid(this.value.id)
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        this.viewComponentModel = val
        if (val && val.id !== '') {
          this.onGetAttributeSetsFromHybrid(val.id)
        }

        this.$set(
          this.viewComponentModel,
          'categoriesMappedItems',
          val.categoriesMappedItems
        )
      },
      deep: true,
    },
  },
  computed: {
    statusLabel() {
      return this.viewComponentModel !== null &&
        this.viewComponentModel.status !== ''
        ? this.viewComponentModel.status.toLowerCase()
        : ''
    },
  },
  methods: {
    genHybridDisplay(input) {
      var result = `${input.display_name_level_1.th}(${input.code_level_1})`
      if (input.code_level_2)
        result += ` > ${input.display_name_level_2.th}(${input.code_level_2})`
      if (input.code_level_3)
        result += ` > ${input.display_name_level_3.th}(${input.code_level_3})`
      if (input.code_level_4)
        result += ` > ${input.display_name_level_4.th}(${input.code_level_4})`
      if (input.code_level_5)
        result += ` > ${input.display_name_level_5.th}(${input.code_level_5})`
      return result
    },
    async onGetAttributeSetsFromHybrid(id) {
      let params = new URLSearchParams()
      params.append('pageSize', 99999)
      params.append('sort', 'display_name.en display_name.th')
      params.append('status', StatusEnum.ACTIVE)
      params.append('isGetIncludeAttributes', true)
      params.append('hybridCategoryId', id)
      let result = await attributesetsService.getAttributeSetsMasterListAsync(
        params
      )
      if (result.status === 200) {
        let attributsetItems = []

        result.data.items.forEach((element, index) => {
          attributsetItems[index] = {
            id: element.id,
            display_name: {
              th: element.display_name ? element.display_name.th : '',
              en: element.display_name ? element.display_name.en : '',
            },
            status: element.status,
          }
        })

        this.attributsetItems = attributsetItems
      }
    },
  },
}
</script>
